import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { applicationHistoryKey, applicationsCountsKey, errorMessage } from '@features/applications';
import { messagesKey, sendMessageRoute } from '@features/messaging';
import axiosInstance from '@server/axiosInstance';

type UseSendMessageProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useSendMessage = ({
  setErrorText = () => { },
}: UseSendMessageProps) => {
  const client = useQueryClient();

  const { mutate: sendMessage, isLoading: isSendingMessage } = useMutation({
    mutationFn: (variables: {
      message: string;
      recipient_id?: number;
      application_id?: number;
      company_id?: string | number;
      message_doc?: File;
    }) => {
      return axiosInstance
        .post(sendMessageRoute, variables, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => res.data);
    },
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([messagesKey]);
        client.invalidateQueries([applicationsCountsKey]);
        client.invalidateQueries([applicationHistoryKey]);
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    sendMessage,
    isSendingMessage,
  };
};
